"use client";

import React from "react";

import { createSVGIcon } from "../util";

/**
 * @deprecated use Earn from foundation/Earn
 * @trackcomponent
 * @donotoptimize missing corner pixel, dollar sign line becomes blurred (@quinlan.sokol)
 */
export const Cash = createSVGIcon(
  <>
    <path
      d="M3.638 3.09091V0.378784H28.6288V14.2879H25.8966"
      stroke="currentColor"
    />
    <path
      d="M25.3471 3.71216H0.371216V17.6212H25.3471V3.71216Z"
      stroke="currentColor"
    />
    <path
      d="M12.8592 15.5152C15.4835 15.5152 17.6109 13.3445 17.6109 10.6667C17.6109 7.98898 15.4835 5.81824 12.8592 5.81824C10.2349 5.81824 8.10754 7.98898 8.10754 10.6667C8.10754 13.3445 10.2349 15.5152 12.8592 15.5152Z"
      stroke="currentColor"
    />
    <path
      d="M14.1511 9.15149C13.8244 8.86361 13.4977 8.7121 13.1413 8.65149V10.3485C14.1659 10.5757 14.5965 10.9848 14.5965 11.6818C14.5965 12.4242 14.0026 12.9242 13.1562 12.9848V13.6666H12.7256V12.9848C12.1316 12.9242 11.597 12.6818 11.1367 12.2727L11.4337 11.8636C11.8346 12.2424 12.2355 12.4697 12.7404 12.5303V10.7879C11.7455 10.5454 11.3001 10.1666 11.3001 9.45452C11.3001 8.7424 11.894 8.22725 12.7256 8.1818V7.77271H13.1562V8.1818C13.661 8.2424 14.0471 8.42422 14.448 8.72725L14.1511 9.15149ZM12.7404 10.2576V8.63634C12.1761 8.65149 11.8198 8.98483 11.8198 9.40907C11.8198 9.80301 11.998 10.0606 12.7404 10.2576ZM13.1413 10.8788V12.5454C13.7204 12.5151 14.0768 12.1818 14.0768 11.7424C14.0768 11.3182 13.8838 11.0757 13.1413 10.8788Z"
      fill="currentColor"
    />
  </>,
  "Cart",
  { viewBox: "0 0 29 18", titleAccess: "Cart", fill: "none" }
);
